// import PropTypes from 'prop-types'
// import React from 'react'
// const Toasts = ({ toastsList }) => {
//   return (
//     <>
//       <div
//         className="toast-container "
//         style={{
//           position: 'fixed',
//           right: '0',
//           top: '0rem',
//           borderRadius: '6px',
//           padding: 6,
//           color: '#fff',
//           zIndex: '9999999'
//         }}
//       >
//         {toastsList?.length > 0 && toastsList?.map((item, i) => {
//           return (
//             <div
//               className="toast show"
//               role="alert"
//               aria-live="assertive"
//               aria-atomic="true"
//               key={i}
//             >
//               <div
//                 className="toast-header"
//                 style={{
//                   backgroundColor: item?.color || '#054757',
//                   color: '#fff',
//                 }}
//               >
//                 <img rel="preload" src={item?.imageUrl} className="rounded me-2" alt="img" />
//                 <strong className="me-auto">{item?.type}</strong>
//                 <small className="text">just now</small>
//                 <button
//                   type="button"
//                   id="closeBtn"
//                   className="btn-close btn-close-white"
//                   data-bs-dismiss="toast"
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="toast-body" style={{ color: '#000' }}>
//                 <ul>
//                   {Array.isArray(item?.name) ? (
//                     item?.name?.map((errorName, inx) => (
//                       <li key={inx}>{errorName}</li>
//                     ))
//                   ) : (
//                     <li>{item?.name}</li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//           )
//         })}
//       </div>
//     </>
//   )
// }

// export default Toasts

// Toasts.propTypes = {
//   toastsList: PropTypes.array,
// }
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

const Toasts = ({ toastsList, autoCloseTime = 3000 }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    setToasts(toastsList);
  }, [toastsList]);

  // Auto close individual toast
  useEffect(() => {
    if (toasts.length > 0) {
      const timers = toasts.map((_, index) =>
        setTimeout(() => handleClose(index), autoCloseTime)
      );
      return () => timers.forEach((t) => clearTimeout(t));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toasts]);

  const handleClose = (index) => {
    setToasts((prevToasts) => prevToasts.filter((_, i) => i !== index));
  };

  return (
    <div
      className="toast-container"
      style={{
        position: "fixed",
        right: "0",
        top: "0rem",
        borderRadius: "6px",
        padding: 6,
        color: "#fff",
        zIndex: "9999999",
      }}
    >
      {toasts.length > 0 &&
        toasts.map((item, i) => (
          <div
            key={i}
            className="toast show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              marginBottom: "10px",
              minWidth: "250px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              borderRadius: "6px",
              overflow: "hidden",
              animation: "fadeIn 0.3s ease",
            }}
          >
            <div
              className="toast-header d-flex align-items-center justify-content-between"
              style={{
                backgroundColor: item?.color || "#054757",
                color: "#fff",
                padding: "8px 10px",
              }}
            >
              {item?.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt="toast icon"
                  className="rounded me-2"
                  style={{ width: 20, height: 20 }}
                />
              )}
              <strong className="me-auto">{item?.type}</strong>
              <small>just now</small>
              <button
                type="button"
                onClick={() => handleClose(i)}
                className="btn-close btn-close-white"
                aria-label="Close"
                style={{
                  marginLeft: "8px",
                  filter: "invert(1)",
                  cursor: "pointer",
                }}
              ></button>
            </div>
            <div
              className="toast-body"
              style={{
                backgroundColor: "#fff",
                color: "#000",
                padding: "10px",
              }}
            >
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                {Array.isArray(item?.name) ? (
                  item.name.map((errorName, inx) => (
                    <li key={inx}>{errorName}</li>
                  ))
                ) : (
                  <li>{item?.name}</li>
                )}
              </ul>
            </div>
          </div>
        ))}
    </div>
  );
};

Toasts.propTypes = {
  toastsList: PropTypes.array,
  autoCloseTime: PropTypes.number, // milliseconds
};

export default Toasts;
